import { createContext, ReactNode, useContext } from 'react';
import shaka from 'shaka-player';

type PlayerContextValue = {
  player: shaka.Player | null;
  getVideoOptions: () => shaka.extern.TrackList;
  getAudioOptions: () => string[];
  getSubtitleOptions: () => shaka.extern.TrackList;
  getActiveTrack: () => shaka.extern.Track | undefined;
  isAbr: () => boolean;
};

const defaultValue = {
  player: null,
  getVideoOptions: () => [],
  getAudioOptions: () => [],
  getSubtitleOptions: () => [],
  getActiveTrack: () => undefined,
  isAbr: () => false,
};

export const PlayerContext = createContext<PlayerContextValue>(defaultValue);

export const PlayerProvider = ({ children, player }: { children: ReactNode; player: shaka.Player }) => {
  let contextValue: PlayerContextValue = defaultValue;
  if (player) {
    contextValue = {
      player,
      getVideoOptions: () => {
        const variantTracks = player.getVariantTracks() ?? [];
        const activeVariant = variantTracks.find(track => track.active);
        if (!activeVariant) return variantTracks;
        return variantTracks.filter(track => track.audioId == activeVariant.audioId);
      },
      getAudioOptions: () => player.getAudioLanguages(),
      getSubtitleOptions: () => player.getTextTracks(),
      getActiveTrack: () => player.getVariantTracks().find(track => track.active),
      isAbr: () => player?.getConfiguration()?.abr?.enabled ?? false,
    };
  }
  return <PlayerContext.Provider value={contextValue}>{children}</PlayerContext.Provider>;
};

export const usePlayerContext = () => useContext(PlayerContext);
